exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro {\n  position: absolute;\n  top: 30%;\n  left: 30%;\n  z-index: 1000;\n  max-width: 50%;\n  border: 1px solid;\n  border-radius: 5px;\n  padding: 10px;\n  background-color: whitesmoke;\n  text-align: center;\n}\n\n.wab-status {\n  color: #3c763d;\n  background-color: #ffddad;\n  border-color: #d6e9c6;\n}\n\n.wb-status > * {\n  margin: 5px;\n  \n  box-shadow: none;\n   /* height: 36px;  */\n  border: none;\n}\n#bottomtools{\n  \n    box-shadow: 0px 0 42px 1px rgba(0, 0, 0, 0.2);\n  \n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/wb-status.component.css
// module id = ../../../../../src/app/wb/wb-status.component.css
// module chunks = main